var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountWhite = function SvgAccountWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1145.05 -137.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.6,
    cy: 7.6,
    r: 7.6,
    fill: "#fff",
    "data-name": "Ellipse 70",
    transform: "translate(1156.45 141.8)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#account-white_svg__clip-path)",
    "data-name": "Groupe de masques 25",
    transform: "translate(1145.05 137.05)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.889,
    cy: 15.833,
    fill: "#fff",
    "data-name": "Ellipse 71",
    rx: 16.889,
    ry: 15.833,
    transform: "translate(2.111 21.111)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    "data-name": "Ellipse 73"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5
  }))))));
};
export { SvgAccountWhite as ReactComponent };
export default "data:image/svg+xml;base64,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";